import { useCallback, useMemo, useState } from 'react';
export function useClientSelection(pageClients) {
    const [selected, setSelected] = useState(()=>new Map());
    const onSelectionChange = useCallback((ids)=>setSelected((previous)=>{
            const selectedOnPage = new Set([
                ...ids
            ].map(String));
            const onPageIds = new Set(pageClients.map((client)=>client.id));
            const offPage = [
                ...previous
            ].filter((param)=>{
                let [id] = param;
                return !onPageIds.has(id);
            });
            const onPage = pageClients.filter((client)=>selectedOnPage.has(client.id)).map((client)=>[
                    client.id,
                    client
                ]);
            return new Map([
                ...offPage,
                ...onPage
            ]);
        }), [
        pageClients
    ]);
    const selectedIds = useMemo(()=>new Set(selected.keys()), [
        selected
    ]);
    const getSelectedIds = useCallback(()=>[
            ...selected.keys()
        ], [
        selected
    ]);
    const clearSelection = useCallback(()=>setSelected(new Map()), []);
    const unselect = useCallback((clientId)=>setSelected((previous)=>new Map([
                ...previous
            ].filter((param)=>{
                let [id] = param;
                return id !== clientId;
            }))), []);
    const hasSharedClientSelected = useMemo(()=>[
            ...selected.values()
        ].some((client)=>client.isMultiVendorCustomer), [
        selected
    ]);
    return {
        selectedIds,
        numSelected: selected.size,
        onSelectionChange,
        getSelectedIds,
        clearSelection,
        unselect,
        hasSharedClientSelected
    };
}
